import {
  addClaimTokenapi,
  addTransactinApi,
  getClaimTokenApi,
  getTransactionApi,
  getUserDashboardApi,
  getUsertokenApi,
} from "../components/config/api";
import { myApi } from "./api";

export const transactionApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    setTransaction: builder.mutation({
      query: (post) => ({
        url: addTransactinApi,
        method: "POST",
        body: post,
      }),
      invalidatesTags: (_) => ["transaction", "stage"],
    }),
    getTransaction: builder.query({
      query: () => ({
        url: getTransactionApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["transaction"],
    }),
    getUserToken: builder.query({
      query: () => ({
        url: getUsertokenApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
    }),
    getUserDashboard: builder.query({
      query: () => ({
        url: getUserDashboardApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? {} : {};
      },
      providesTags: (_) => ["transaction"],
    }),
    getClaimToken: builder.query({
      query: () => ({
        url: getClaimTokenApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? {} : {};
      },
      providesTags: (_) => ["claimtoken"],
    }),
    setClaimToken: builder.mutation({
      query: (post) => ({
        url: addClaimTokenapi,
        method: "POST",
        body:post
      }),
      invalidatesTags: (_) => ["claimtoken"],
    }),
  }),
});

export const {
  useSetTransactionMutation,
  useGetTransactionQuery,
  useGetUserTokenQuery,
  useGetUserDashboardQuery,
  useGetClaimTokenQuery,
  useSetClaimTokenMutation
} = transactionApi;
